import React, { useState } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { closeButtonStyle, Saveandadduser } from "../components/Propertyfile";
import { List_Checker, Add_User, userinfo } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { Modal } from 'react-bootstrap';

const GapsyUserRegistration = () => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const navigate = useNavigate();
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        userPassword: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedChecker, setSelectedChecker] = useState('');
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const fetchLdapUserDetails = async () => {
        const userId = (formData.searchUserId || '').trim();

        if (!userId) {
            console.log("Please enter a User ID to fetch.");
            return;
        }

        try {
            const config = {
                params: { userId: userId },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(userinfo, {}, config);
            const data = response.data;

            const departmentFromApi = data.department?.trim() || '';

            // Add to dropdown if not exists
            if (departmentFromApi && !departments.some(dept => dept.name === departmentFromApi)) {
                setDepartments(prev => [
                    ...prev,
                    { id: prev.length + 1, name: departmentFromApi }
                ]);
            }

            // Set form data first
            setFormData(prev => ({
                ...prev,
                userId: data.userId || '',
                userFirstName: data.firstName || '',
                userLastName: data.lastName || '',
                userEmail: data.mail || '',
                userLocation: '',
                orgHierarchy: departmentFromApi,
                mappedId: '',
                userRole: '',
                searchUserId: userId
            }));

            //  Then trigger hierarchy change (DON’T modify the handler logic itself)
            if (departmentFromApi) {
                handleHierarchyChange(departmentFromApi);
            }

        } catch (error) {
            console.error('Error fetching LDAP user info:', error);
        }
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();
        try {
            const {
                userId,
                userFirstName,
                userLastName,
                userEmail,
                userPassword,
                userRole,
                orgHierarchy,
                userLocation,
                mappedId
            } = formData;

            const adminId = localStorage.getItem('userid') || '';

            // Validate required fields
            if (!userId) {
                setMessageType('error');
                setModalMessage("User Id is required");
                return;
            }
            if (!userFirstName) {
                setMessageType('error');
                setModalMessage("Firstname is required");
                return;
            }
            if (!userRole) {
                setMessageType('error');
                setModalMessage("User Role is required");
                return;
            }
            if (userRole === 'Maker' && !mappedId) {
                setMessageType('error');
                setModalMessage("Mapped ID is required for Maker role");
                return;
            }
            if (!userEmail) {
                setMessageType('error');
                setModalMessage("Email Id is required");
                return;
            }
            if (!validateEmail(userEmail)) {
                setMessageType('error');
                setModalMessage('Please enter a valid email');
                return;
            }
            if (!orgHierarchy) {
                setMessageType('error');
                setModalMessage("Hierarchy is required");
                return;
            }

            setIsLoading(true);

            const config = {
                params: {
                    adminId,
                    userId,
                    userFirstName,
                    userRole,
                    userLastName,
                    userEmail,
                    orgHierarchy,
                    userLocation,
                    mappedId: mappedId || "",
                    active_yn: 'Y'
                },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(Add_User, {}, config);

            const newUser = { ...response.data, active_yn: 'Y', newlyCreated: true };
            const updatedUsers = [...users, newUser];

            setUsers(updatedUsers);
            setFilteredUsers(updatedUsers);

            setMessageType('success');
            setModalMessage(response.data.message);
            setTimeout(() => setMessage(null), 5000);

            // Reset form
            setFormData({
                adminId: '',
                userId: '',
                userFirstName: '',
                userLastName: '',
                userEmail: '',
                userPassword: '',
                userRole: '',
                orgHierarchy: '',
                userLocation: '',
                mappedId: '',
                active_yn: ''
            });

            setSelectedRole('');
            setHierarchy('');
            setPasswordGenerated(false);
        } catch (error) {
            console.error('LDAP Submission Error:', error);
            setMessageType('error');
            setModalMessage('There was an error processing your request. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        // Clear mappedId if changing from Checker to Maker
        if (selectedRole === 'Checker' && newRole === 'Maker') {
            localStorage.removeItem('mappedId');
        }

        setFormData({
            ...formData,
            userRole: newRole,
        });
        setSelectedRole(newRole);
    };


    const validateEmail = (inputEmail) => {
        // Regular expression for basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const handleCloseLdap = () => {
        setShowModalLdap(false);
        setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleFocus = (e) => {
        const { name } = e.target;
        if (!validateField(name)) {
            e.preventDefault();
        }
    };
    const handleHierarchyChange = async (hierarchyValue) => {
        // Update form state
        setFormData((prevFormData) => ({
            ...prevFormData,
            orgHierarchy: hierarchyValue,
        }));

        // Update hierarchy state
        setHierarchy(hierarchyValue);

        try {
            // 2. Second API call - Fetch list of checkers (only if hierarchyValue means which we selected in dropdown)
            if (hierarchyValue) {
                const config = {
                    params: {
                        "adminId": localStorage.getItem('userid'),
                        "dept": hierarchyValue
                    },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };
                // const response = await axios.post('http://172.16.119.156:8081/api/user/list_checkers', {}, config);
                const checkersResponse = await axios.post(List_Checker, {}, config);
                setCheckerData(checkersResponse.data.checkers_list);

            }
        } catch (error) {
            console.error('Error in handleHierarchyChange:', error.message);
            setSelectedLocationValues([]);
            setCheckerData([]); // Reset checkers data on error
        }
    };

    const handleCheckers = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setSelectedChecker(e.target.value);
    };

    const validateField = (fieldName) => {
        if (fieldName === 'userFirstName' && !formData.userId) {
            setError('User Id is required');
            return false;
        }
        if (fieldName === 'userEmail' && !formData.userId) {
            setError('User Name is required');
            return false;
        }
        if (fieldName === 'userPassword' && !formData.userId) {
            setError('User Password is required');
            return false;
        }
        // Clear error message if validation passes
        setError(null);
        return true;
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleCloseModal = () => {
        setModalMessage('');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>Register New User
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className='row'>
                                    <div className="col justify-content-center">
                                        <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                            <div className="card-body">
                                                <div className="mb-0">
                                                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Register New User</h6>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="w-100" style={{ maxWidth: '700px' }}>
                                                            <div className={`mx-auto ${formStyles.formWrapper}`}>



                                                                {isLoading && (
                                                                    <>
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            right: 0,
                                                                            bottom: 0,
                                                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                                            zIndex: 1040
                                                                        }} />
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            zIndex: 1050
                                                                        }}>
                                                                            <div className="spinner-border text-dark" role="status">
                                                                                <span className="visually-hidden">Loading...</span>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}


                                                                <form className="form px-5" onSubmit={handleLdapSubmit} >
                                                                    <>
                                                                        <input type="hidden" name="adminId" value={localStorage.getItem('userid')} readOnly />

                                                                        <div className="form-group row mb-1">
                                                                            <label className="col-sm-4 col-form-label text-small label-black">USER ID</label>
                                                                            <div className="col-sm-7">
                                                                                <div className="d-flex">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        name="searchUserId"
                                                                                        value={formData.searchUserId || ''}
                                                                                        onChange={handleChange}
                                                                                        placeholder="Search Ldap Ad Id"
                                                                                    />
                                                                                    <button
                                                                                        className="btn btn-outline-secondary btn-sm mt-0 ms-2 d-flex align-items-center"
                                                                                        type="button"
                                                                                        onClick={fetchLdapUserDetails}
                                                                                    >
                                                                                        <i className="bi bi-cloud-download me-1"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-group row mb-1">
                                                                            <label className="col-sm-4 col-form-label text-small label-black">FIRST NAME</label>
                                                                            <div className="col-sm-7">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    name="userFirstName"
                                                                                    value={formData.userFirstName}
                                                                                    onChange={handleChange}
                                                                                    onFocus={handleFocus}
                                                                                    disabled={disableInputs}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="form-group row mb-1">
                                                                            <label className="col-sm-4 col-form-label text-small label-black">LAST NAME</label>
                                                                            <div className="col-sm-7">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    name="userLastName"
                                                                                    value={formData.userLastName}
                                                                                    onChange={handleChange}
                                                                                    onFocus={handleFocus}
                                                                                    disabled={disableInputs}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="form-group row mb-1">
                                                                            <label className="col-sm-4 col-form-label text-small label-black">EMAIL ID</label>
                                                                            <div className="col-sm-7">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    name="userEmail"
                                                                                    value={formData.userEmail}
                                                                                    onChange={handleChange}
                                                                                    onFocus={handleFocus}
                                                                                    disabled={disableInputs}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>

                                                                    <div className="form-group row mb-1">
                                                                        <label className="col-sm-4 col-form-label text-small label-black">DEPARTMENT</label>
                                                                        <div className="col-sm-7">
                                                                            <select
                                                                                className="form-control form-control-sm"
                                                                                name="orgHierarchy"
                                                                                onChange={(e) => handleHierarchyChange(e.target.value)}
                                                                                value={formData.orgHierarchy}
                                                                            >
                                                                                <option value="">Select a Department</option>
                                                                                {departments
                                                                                    .slice()
                                                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                                                    .map((dept) => (
                                                                                        <option key={dept.id} value={dept.name}>
                                                                                            {dept.name}
                                                                                        </option>
                                                                                    ))}
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-group row mb-1">
                                                                        <label className="col-sm-4 col-form-label text-small label-black d-flex align-items-center">ROLE</label>
                                                                        <div className="col-sm-7 d-flex align-items-center">
                                                                            <div className="row w-100">
                                                                                <div className="col-md-4">
                                                                                    <div className="form-check py-1">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="userRole"
                                                                                            value="Admin"
                                                                                            checked={selectedRole === 'Admin'}
                                                                                            onChange={handleRoleChange}
                                                                                        />
                                                                                        <label className="form-check-label">Manager</label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="form-check py-1">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="userRole"
                                                                                            value="Checker"
                                                                                            checked={selectedRole === 'Checker'}
                                                                                            onChange={handleRoleChange}
                                                                                        />
                                                                                        <label className="form-check-label">Checker</label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="form-check py-1">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="userRole"
                                                                                            value="Maker"
                                                                                            checked={selectedRole === 'Maker'}
                                                                                            onChange={handleRoleChange}
                                                                                        />
                                                                                        <label className="form-check-label">Maker</label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {selectedRole === 'Maker' && (checkerData?.length ?? 0) > 0 && (
                                                                        <div className="form-group row mb-1">
                                                                            <label className="col-sm-4 col-form-label text-small label-black">ASSIGN CHECKER</label>
                                                                            <div className="col-sm-7">
                                                                                <select
                                                                                    className="form-control form-control-sm"
                                                                                    name="mappedId"
                                                                                    value={formData.mappedId}
                                                                                    onChange={handleCheckers}
                                                                                >
                                                                                    <option value="">Select a Checker</option>
                                                                                    {checkerData.map(checker => (
                                                                                        <option key={checker.userId} value={checker.userId}>
                                                                                            {checker.userName}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="form-group row mt-1">
                                                                        <div className="col-sm-4"></div>
                                                                        <div className="col-sm-7 d-flex mx-2">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-secondary me-2"
                                                                                onClick={handleCloseLdap}
                                                                                style={closeButtonStyle}
                                                                            >
                                                                                Clear
                                                                            </button>
                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-sm btn-primary"
                                                                                style={Saveandadduser}
                                                                                disabled={disableInputs}

                                                                            >
                                                                                Register
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Modal for messages */}
                                        <Modal
                                            show={!!modalMessage}
                                            onHide={handleCloseModal}
                                            backdrop="static"
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            color: messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? '#ffc107'
                                                                    : 'red'
                                                        }}
                                                    >
                                                        {modalMessage}
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleCloseModal}
                                                    style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                                />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyUserRegistration;
